import { ALLOWED_ORIGINS } from "@nextlayer/stealth-shared";

const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? "https://api.nextlayer.tech";

export const AUTH_URL = `${API_BASE_URL}/auth`;
export const INVOICE_REQUEST_URL = `${API_BASE_URL}/invoice/request`;
export const INVOICE_STATUS_URL = `${API_BASE_URL}/invoice/status`;

export const POLL_INTERVAL_MS = 3000;

// Demo/dev flag: when on, the API layer returns stubbed responses (no backend).
export const STUB = import.meta.env.VITE_STUB === "true";

// Only post payment outcomes back to an https merchant origin (localhost allowed
// for dev). Rejecting http/other schemes keeps the outcome channel off downgradable
// transports — a partial hardening on top of the exact-origin postMessage guard.
function isTrustedMerchantOrigin(url: URL): boolean {
  if (url.protocol === "https:") return true;
  return (
    url.protocol === "http:" &&
    (url.hostname === "localhost" || url.hostname === "127.0.0.1")
  );
}

export function getSdkOrigin(): string {
  if (STUB) return window.location.origin;
  const raw = new URLSearchParams(window.location.search).get("origin");
  if (raw) {
    try {
      const url = new URL(raw);
      if (isTrustedMerchantOrigin(url)) return url.origin;
    } catch {}
  }
  return ALLOWED_ORIGINS[0];
}
